import React, { useEffect, useRef } from "react";
import { Box, IconButton, Drawer } from "@mui/material";
import { mobiliTheme } from "../themes/mobiliTheme";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import useStore from "../helpers/useStore";
import { CalendarContext } from "../stores/Calendar/calendar.provider";
import { observer } from "mobx-react";

const HoverSidebar: React.FC<{
  children: React.ReactNode;
  onToggle?: (open: boolean) => void;
  width: string;
}> = observer(({ children, onToggle, width }) => {
  const CalendarStore = useStore(CalendarContext);
  const { cancellationDrawerOpen, setCancellationDrawerOpen } = CalendarStore;
  const { continuousView } = CalendarStore || ({} as any);

  // Single resize after this sidebar's own width transition ends
  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sidebarRef.current;
    if (!el) return;
    const onEnd = (e: TransitionEvent) => {
      if (e.propertyName === "width") {
        window.dispatchEvent(new Event("resize"));
      }
    };
    el.addEventListener("transitionend", onEnd);
    return () => el.removeEventListener("transitionend", onEnd);
  }, []);

  const handleMouseEnter = () => {
    setCancellationDrawerOpen(true);
    onToggle?.(true);
  };

  const handleMouseLeave = () => {
    setCancellationDrawerOpen(false);
    onToggle?.(false);
  };
  return (
    <>
      {cancellationDrawerOpen && (
        <IconButton
          onClick={() => {
            setCancellationDrawerOpen(!cancellationDrawerOpen);
            onToggle?.(!cancellationDrawerOpen);
          }}
          sx={{
            position: "absolute",
            top: "50%",
            right: 0,
            transform: "translateY(-50%)",
            cursor: "pointer",
            transition: "right 0.3s ease",
            zIndex: 500,
            padding: "10px",
          }}
        >
          <ArrowForwardIos
            sx={{
              fontSize: "15px",
              transform: "scale(2.0)",
              fontWeight: "bold",
            }}
          />
        </IconButton>
      )}

      <div
        ref={sidebarRef}
        onClick={handleMouseEnter}
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: cancellationDrawerOpen ? width : "20px",
          transition: "width 0.3s ease",
          zIndex: 500,
        }}
      >
        <IconButton
          onClick={() => {
            setCancellationDrawerOpen(!cancellationDrawerOpen);
            onToggle?.(!cancellationDrawerOpen);
          }}
          sx={{
            position: "absolute",
            top: "50%",
            right: 0,
            transform: "translateY(-50%)",
            cursor: "pointer",
            transition: "right 0.3s ease",
            zIndex: 500,
            padding: "10px",
          }}
        >
          {cancellationDrawerOpen ? (
            <ArrowForwardIos
              sx={{
                fontSize: "15px",
                transform: "scale(2.0)",
                fontWeight: "bold",
              }}
            />
          ) : (
            <ArrowBackIos
              sx={{
                fontSize: "15px",
                transform: "scale(2.0)",
                fontWeight: "bold",
              }}
            />
          )}
        </IconButton>

        <Drawer
          anchor="right"
          variant="persistent"
          open={cancellationDrawerOpen}
          PaperProps={{
            sx: {
              zIndex: 500,
              width: cancellationDrawerOpen ? width : 0,
              transition: "width 0.3s ease",
              overflowX: "hidden",
              boxSizing: "border-box",
              marginLeft: 5,
              marginTop: 8,
              backgroundColor: `${mobiliTheme.topLevelBackground}`,
            },
          }}
        >
          <Box
            sx={{
              padding: 2,
              overflowY: "auto",
              height: "100%",
              width: width,
              boxSizing: "border-box",
            }}
          >
            {children}
          </Box>
        </Drawer>
      </div>
    </>
  );
});

export default HoverSidebar;
